import { createLazyResolver } from 'owa-lazy-resolver';

export const lazyRoomListQueryWeb = createLazyResolver(
    'ROOMLIST_QUERY_WEB',
    () => import(/* webpackChunkName: "RoomListQueryWeb" */ './roomListQueryWeb'),
    m => m.roomListQueryWeb
);
